import { OrganizationUserListState } from "./UserList-State";

export default function userListReducer(
  state = OrganizationUserListState,
  action
) {
  let { data } = { ...state };
  let { name, value } = action;

  switch (action.type) {
    case "TOGGLE-ORGANIZATION-USER-LIST-FILTER":
      let toggle = true;
      if (toggle) {
        if (name === "limit") {
          data.params.page = 1;
        }
        data.params[name] = value;
      }
      data.params[name] = value;
      // if ( name === `sort_id` ) {
      //   if ( data.params.sort_id === value ) {
      //     data.params.sort_order = data.params.sort_order === `desc` ? `asc` : `desc`
      //   }
      // }
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      return { ...state, data };

    case "RESET-SEARCH-PARAMS":
      data.params.q = "";
      data.params.page = 1;
      data.payload.initialLoading = true;
      return { ...state, data };

    default:
      return state;
  }
}
